import React from 'react';
import millify from 'millify';
import { Typography, Row, Col, Statistic, Card } from 'antd';
import { Link } from 'react-router-dom';
import { useGetCryptosQuery } from '../services/cryptoAPI';
import { Cryptocurrencies } from '../components';
import Loader from './Loader';


const { Title } = Typography;

const Homepage = () => {

    const { data, isFetching } = useGetCryptosQuery(10);
    const globalStats = data?.data?.stats;


    if(isFetching) return <Loader/>;
    // console.log(globalStats);

    return (
        <>
        <Title level={3} className="heading">
        Worldwide Cryptocurrency Statistics
        </Title>
        <Card style={{borderRadius: '15px', backgroundColor: 'rgb(216,213,237)'}}>
        <Row>
            <Col span={12}><Statistic style={{fontWeight: 'bold'}} title="Total Cryptocurrencies" value={globalStats.total} /></Col>
            <Col span={12}><Statistic style={{fontWeight: 'bold'}} title="Total Exchanges" value={millify(globalStats.totalExchanges)} /></Col>
            <Col span={12}><Statistic style={{fontWeight: 'bold'}} title="Total Market Capital" value={millify(globalStats.totalMarketCap)} /></Col>
            <Col span={12}><Statistic style={{fontWeight: 'bold'}} title="Total 24h Volume" value={millify(globalStats.total24hVolume)} /></Col>
            <Col span={12}><Statistic style={{fontWeight: 'bold'}} title="Total Markets" value={millify(globalStats.totalMarkets)} /></Col>
        </Row>
        </Card>
      
        <div className="home-heading-container">
         <Title level={3} className="home-title">Top 10 Cryptocurrencies in the world</Title>
         <Title level={5} className="show-more"><Link to="/cryptocurrencies">Show More</Link></Title>
        </div>
        <Cryptocurrencies simplified />
        {/* <div className="home-heading-container">
         <Title level={2} className="home-title">Latest Crypto News</Title>
         <Title level={3} className="show-more"><Link to="/news">Show More</Link></Title>
        </div>
        <News simplified /> */}
        </>
    )
}

export default Homepage
